var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "field",
    {
      attrs: {
        label: _vm.label,
        disabled: _vm.disabled,
        "error-text": _vm.errorText,
      },
    },
    [
      _c("dropdown-field", {
        attrs: {
          source: _vm.source,
          "no-items-found-text": "NO VENDORS FOUND",
          "taggable-no-items-found-text": "ADD NEW VENDOR WITH ENTER OR",
          "taggable-add-item-text": "ADD VENDOR",
          "text-field": "name",
          "value-field": "internalId",
          "auto-assign": _vm.autoAssign,
          placeholder: _vm.placeholder,
          taggable: _vm.taggable,
          searchable: "",
        },
        on: {
          "add-tag": function ($event) {
            return _vm.addNewVendor($event)
          },
        },
        model: {
          value: _vm.val,
          callback: function ($$v) {
            _vm.val = $$v
          },
          expression: "val",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }